<script setup lang="ts">
import { cn } from "@/lib/utils";
import { eventBus } from "#bb/lib/eventBus";
import { useTemplating, buildTemplateContext } from "#bb/composables/useTemplating";

// 1) Define props & emits
const props = defineProps<{ id: string; text?: string }>();

// 2) Access content manager for store updates
const { getContentById } = useContentManager();
// Use a computed property so updates from the store are reflected
const definitionData = computed(() => getContentById(props.id) || { text: props.text });

// Inject report for templating
const report = inject<any | null>("report", null);
const templateContext = computed(() => buildTemplateContext(report));
const logger = useLogger("CardHeaderDescription");
const { applyTemplate } = useTemplating(templateContext, { logger });
const templatedText = computed(() => applyTemplate(definitionData.value?.text || ""));


// 4) Expose an "Edit" command in the context menu
const commands = [
  {
    id: "editors-group",
    type: "group",
    name: "Editors",
    description: "Edit the description text",
    commands: [
      {
        id: "edit",
        name: "Edit Description",
        description: "Edit Card Header Description",
        action: async () => {
          eventBus.emit(`component:onEdit:${props.id}`, {
            data: { ...definitionData.value },
          });
        },
        icon: "lucide:edit",
      },
    ],
  },
];

defineExpose({
  commands,
  properties: {
    id: props.id,
    name: "Card Header Description",
    icon: "lucide:text-quote",
  },
});
</script>

<template>
  <!-- Renders the card description using the ShadCN CardDescription component -->
  <CardDescription :class="cn($attrs.class ?? '')">
    {{ templatedText }}
  </CardDescription>

</template>

<script lang="ts">
import { ComponentDefinitionIds } from "#bb/lib/componentDefinitionIds";
export default {
  componentId: ComponentDefinitionIds.CARD_HEADER_DESCRIPTION,
  editor: () => import("#bb/components/editor/container/card/header/description.vue"),
  icon: "lucide:text-quote",
  type: "Card Header Description",
  description: "Displays a secondary text in the card header.",
  default: {
    text: "Default description text...",
  },
  categories: ["Layout"],
  hiddenUntilFiltered: true,
};
</script>
